import React from 'react'
import { Outlet } from 'react-router-dom'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import ScrollToTop from '../../components/ScrollToTop'
import Step from '../../components/Step'

import './index.scss'

const TicketLayout = () => {

    return (
        <>
            <Header />
            <div className="container__outlet">
                <div className="header-step">
                    <Step />
                </div>
                <Outlet />
            </div>
            <Footer />
            <ScrollToTop />
        </>
    )
}

export default TicketLayout